var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0106 5.22681L11.6606 5.91531L5.13676 9.23799C5.04381 8.52395 5.15107 7.79812 5.44657 7.14148C5.74206 6.48484 6.21418 5.92321 6.81025 5.51923C7.40633 5.11526 8.10291 4.88483 8.8223 4.85366C9.5417 4.82248 10.2556 4.99179 10.8844 5.34268L11.6573 4.94893L11.7726 4.88987C11.0394 4.35779 10.1692 4.04664 9.26486 3.99315C8.36052 3.93966 7.45975 4.14606 6.66892 4.58799C5.8781 5.02992 5.23025 5.68892 4.80187 6.48716C4.37349 7.28541 4.18248 8.18957 4.25139 9.09287C4.26428 9.26277 4.22662 9.43269 4.14314 9.58123C4.05966 9.72977 3.9341 9.85029 3.78226 9.92762L3.37445 10.1357V11.1055L4.57483 10.4935L4.96351 10.2949L5.34658 10.0997L12.2237 6.59537L12.9966 6.20218L14.5941 5.38824V4.41906L13.0106 5.22681ZM14.5946 6.35856L5.73808 10.8676L4.9652 11.2613L3.37501 12.073V13.0422L4.95451 12.2378L6.30508 11.5493L12.8357 8.22156C12.9301 8.93669 12.8235 9.66398 12.5281 10.322C12.2326 10.98 11.7598 11.5429 11.1626 11.9474C10.5654 12.352 9.86737 12.5824 9.14668 12.6128C8.42598 12.6433 7.71105 12.4725 7.08189 12.1197L7.03408 12.145L6.19595 12.5725C6.92928 13.1049 7.79966 13.4162 8.70427 13.4697C9.60889 13.5233 10.5099 13.3167 11.3009 12.8746C12.0919 12.4324 12.7398 11.7731 13.1681 10.9745C13.5963 10.1758 13.7871 9.27134 13.7177 8.36781C13.7049 8.19807 13.7426 8.02834 13.826 7.87993C13.9093 7.73152 14.0347 7.61104 14.1863 7.53362L14.5946 7.32549V6.35912V6.35856Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlm);
export default __webpack_public_path__ + "static/media/xlm.cd32d5a9d3324c6adf102a65aa5d34fc.svg";
export { ForwardRef as ReactComponent };